let searchIcons = document.querySelectorAll('.search-icon-js');
if(searchIcons) {
  searchIcons.forEach(function (icon) {
    let wrap = icon.parentElement;
    icon.addEventListener('click', function (event) {
      wrap.classList.toggle('active');
      if (wrap.classList.contains('active')) {
        // we need to delay after element is visible to user
        // https://stackoverflow.com/questions/15859113/focus-not-working
        setTimeout(function () {
          wrap.querySelector('input.search-input').focus();
        }, 300);
      }
      event.stopPropagation();
      event.preventDefault();
    })
    document.addEventListener('click', function (event) {
      if (!wrap.contains(event.target)) {
        wrap.classList.remove('active');
      }
    })
  })
}
